import { render, staticRenderFns } from "./HomeGestor.vue?vue&type=template&id=5bf27693&scoped=true"
import script from "./HomeGestor.vue?vue&type=script&lang=js"
export * from "./HomeGestor.vue?vue&type=script&lang=js"
import style0 from "./HomeGestor.vue?vue&type=style&index=0&id=5bf27693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf27693",
  null
  
)

export default component.exports